import { render, staticRenderFns, recyclableRender, components } from "./u-tabs-swiper.vue?vue&type=template&id=6a7e75c7&scoped=true&"
var renderjs
import script from "./u-tabs-swiper.vue?vue&type=script&lang=js&"
export * from "./u-tabs-swiper.vue?vue&type=script&lang=js&"
import style0 from "./u-tabs-swiper.vue?vue&type=style&index=0&id=6a7e75c7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7e75c7",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-tabs-swiper/u-tabs-swiper.vue"
export default component.exports